<template>
    <div class="container">
        <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="單位代號" :label-width="formLabelWidth" prop="code">
                <el-input v-model="form.code" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="帳號" :label-width="formLabelWidth" prop="username">
                <el-input v-model="form.username" autocomplete="off"></el-input>
            </el-form-item>


            <el-form-item label="管理密碼" :label-width="formLabelWidth" prop="password">
                <el-input type="password" v-model="form.password"
                    autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="確認密码" prop="checkPassword" :label-width="formLabelWidth">
                <el-input type="password" v-model="form.checkPassword"
                    autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submit">確 定</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
  name: "userRestPwd",

  created() {

  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "" && this.orgId == null) {
        callback(new Error("請輸入密碼"));
      } else {
        if (this.form.checkPassword !== "") {
          this.$refs.form.validateField("checkPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "" && this.orgId == null) {
        callback(new Error("請再次輸入密碼"));
      } else if (value !== this.form.password) {
        callback(new Error("兩次輸入密碼不一致!"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        code: [
          { required: true, message: "請輸入代號", trigger: "blur" },
          /*{ validator: validateCode, trigger: 'blur' },*/
        ],
        username: [{ required: true, message: "請輸入帳號", trigger: "blur" }],
        password: [
          { required: true, message: '請輸入密碼', trigger: 'blur' },
          { validator: validatePass, trigger: "blur" },
        ],
        checkPassword: [
          { required: true, message: '請確認密碼', trigger: 'blur' },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      formLabelWidth: "100px",
      form: {
        code: "",
        username: "",
        password: "",
        checkPassword: "",
      },
    };
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
            this.submitUpdate();
        } else {
          return false;
        }
      });
    },
    submitUpdate() {
      this.$store.dispatch("user/resetPwd", this.form).then(() => {
        this.$message({
              type: "success",
              message: "重設成功!",
            });
      }).catch(()=>{
        this.$message({
              type: "error",
              message: "重設失敗!",
            });
      });
    },
  }
};
</script>